import {
  Button,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  TextField as TextFieldMt,
  Dialog,
  DialogContent,
} from '@mui/material'
import PrimeTable from '../../../components/PrimeTable'
import { useCallback, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { setSuccess } from '../../../components/alerts'

export const listaSituacao = [
  ['S', 'Sim'],
  ['N', 'Não'],
]

export const STATUS_MAP = {
  S: {
    label: 'Sim',
    color: '#395c42',
    background: '#47de29',
  },
  N: {
    label: 'Não',
    color: '#ffffff',
    background: '#f53a3a',
  },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const ModalOpcoes = ({
  data,
  openModalDadosCadastrais,
  setOpenModalDadosCadastrais,
}) => {
  const [refresh, setRefresh] = useState(0)
  const handleFalse = () => {
    setRefresh((v) => !v)
    setOpenModalDadosCadastrais(false)
  }

  const exclui = useCallback((dados) => {
    metodoPrograma('excluiOpcaoPergunta', {
      idQuestionario: dados[0],
      idPergunta: dados[1],
      nrOpcao: dados[2],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const salvaOpcaoPergunta = async (valuesTabela) => {
    const payload = {
      idQuestionario: data[0],
      idPergunta: data[1],
      dsNome: valuesTabela.dsNome,
      snJustifica: valuesTabela.snJustifica,
    }

    const resp = await metodoPrograma('salvaOpcaoPergunta', payload)

    if (resp.status) {
      setSuccess('Opção Cadastrada')
      setRefresh((v) => !v)
    }
  }

  const editarOpcaoPergunta = async (linha, close) => {
    const payload = {
      idQuestionario: linha?.[0],
      idPergunta: linha?.[1],
      nrOpcao: linha?.[2],
      dsNome: linha?.[3],
      snJustifica: linha?.[6],
    }
    const resp = await metodoPrograma('salvaOpcaoPergunta', payload)

    if (resp.status) {
      setSuccess('Opção Alterada')
      setRefresh((v) => !v)
    }
    close()
  }

  const salvaColunaOpcaoPergunta = async (valuesTabela) => {
    const payload = {
      idQuestionario: data[0],
      idPergunta: data[1],
      dsColuna: valuesTabela.dsColuna,
    }

    const resp = await metodoPrograma('salvaColunaOpcaoPergunta', payload)

    if (resp.status) {
      setSuccess('Coluna Cadastrada')
      setRefresh((v) => !v)
    }
  }

  const editarColunaOpcaoPergunta = async (linha, close) => {
    const payload = {
      idQuestionario: linha?.[0],
      idPergunta: linha?.[1],
      sqColuna: linha?.[2],
      dsColuna: linha?.[3],
    }
    const resp = await metodoPrograma('salvaOpcaoPergunta', payload)

    if (resp.status) {
      setSuccess('Opção Alterada')
      setRefresh((v) => !v)
    }
    close()
  }

  const excluiColuna = useCallback((dados) => {
    metodoPrograma('excluiColunaOpcaoPergunta', {
      idQuestionario: dados[0],
      idPergunta: dados[1],
      sqColuna: dados[2],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={openModalDadosCadastrais}
      onClose={handleFalse}
    >
      <DialogTitle divider>Opções da Pergunta</DialogTitle>
      <Divider />
      <DialogContent>
        Opções
        <PrimeTable
          codigo="CtrlQuestionario"
          action="listaOpcaoPergunta"
          rows={9999}
          habSearch
          parametros={{ idQuestionario: data?.[0], idPergunta: data?.[1] }}
          head={['#', 'Pergunta', 'Justifica', 'Inclusão', 'Exclusão']}
          line={(item) => [
            item[2],
            item[3],
            item?.[6] ? <StatusChip status={item[6]} /> : '',
            item[4],
            item[5],
          ]}
          collumnsDateHour={[3, 4]}
          onDelete={{ index: 4, action: exclui }}
          refresh={refresh}
          editButton={true}
          addButton={true}
          colStyle={[
            { width: '2%' },
            { width: '55%' },
            { width: '15%' },
            { width: '15%' },
            { width: '15%' },
          ]}
          fastAddComponent={({ values, edit, close }) => (
            <Grid container spacing={2}>
              <Grid item md={12}>
                <TextFieldMt
                  InputLabelProps={{ shrink: true }}
                  name="dsNome"
                  label="Nome da Opção"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  value={values?.dsNome}
                  onChange={(e) =>
                    edit({
                      value: e.target.value,
                      field: 'dsNome',
                    })
                  }
                />
              </Grid>
              <Grid item md={12}>
                <TextFieldMt
                  InputLabelProps={{ shrink: true }}
                  name="snJustifica"
                  label="Necessita Justificativa"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  select
                  value={values?.snJustifica}
                  onChange={(e) =>
                    edit({
                      value: e.target.value,
                      field: 'snJustifica',
                    })
                  }
                  helperText={!values?.snJustifica ? 'Campo Obrigatório!' : ''}
                  error={!values?.snJustifica}
                >
                  <MenuItem value="N">Não</MenuItem>
                  <MenuItem value="S">Sim</MenuItem>
                </TextFieldMt>
              </Grid>
              <Grid
                item
                container
                md={12}
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item md={6}>
                  <Button
                    onClick={close}
                    fullWidth
                    variant="contained"
                    color="inherit"
                    style={{ margin: '5px' }}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item md={6}>
                  <Button
                    onClick={() =>
                      !!values?.dsNome && salvaOpcaoPergunta(values) && close()
                    }
                    variant="contained"
                    fullWidth
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          fastEditComponent={({ linha, close, edit }) => (
            <Grid container spacing={2}>
              <Grid item md={12}>
                <TextFieldMt
                  InputLabelProps={{ shrink: true }}
                  name="dsNome"
                  label="Nome da Opção"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  value={linha[3]}
                  onChange={(e) => edit({ value: e.target.value, index: 3 })}
                  helperText={!linha?.[3] ? 'Campo Obrigatório!' : ''}
                  error={!linha?.[3]}
                />
              </Grid>
              <Grid item md={12}>
                <TextFieldMt
                  InputLabelProps={{ shrink: true }}
                  name="snJustifica"
                  label="Necessita Justificativa"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  select
                  value={linha[6]}
                  onChange={(e) => edit({ value: e.target.value, index: 6 })}
                  helperText={!linha?.[6] ? 'Campo Obrigatório!' : ''}
                  error={!linha?.[6]}
                >
                  <MenuItem value="N">Não</MenuItem>
                  <MenuItem value="S">Sim</MenuItem>
                </TextFieldMt>
              </Grid>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={close}
                    fullWidth
                    variant="contained"
                    color="inherit"
                    style={{ margin: '5px' }}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={() =>
                      !!linha?.[4] &&
                      !!linha?.[6] &&
                      editarOpcaoPergunta(linha, close) &&
                      close()
                    }
                    variant="contained"
                    fullWidth
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Editar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        />
        Colunas
        <PrimeTable
          codigo="CtrlQuestionario"
          action="listaColunaPergunta"
          rows={999}
          habSearch
          parametros={{ idQuestionario: data?.[0], idPergunta: data?.[1] }}
          head={['#', 'Nome da Coluna', 'Inclusão', 'Exclusão']}
          line={(item) => [item[2], item[3], item[4], item[5]]}
          collumnsDateHour={[2, 3]}
          onDelete={{ index: 3, action: excluiColuna }}
          refresh={refresh}
          editButton={true}
          addButton={true}
          colStyle={[
            { width: '2%' },
            { width: '55%' },
            { width: '15%' },
            { width: '15%' },
            { width: '15%' },
          ]}
          fastAddComponent={({ values, edit, close }) => (
            <Grid container spacing={2}>
              <Grid item md={12}>
                <TextFieldMt
                  InputLabelProps={{ shrink: true }}
                  name="dsColuna"
                  label="Nome da Coluna"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  value={values?.dsColuna}
                  onChange={(e) =>
                    edit({
                      value: e.target.value,
                      field: 'dsColuna',
                    })
                  }
                />
              </Grid>
              <Grid
                item
                container
                md={12}
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item md={6}>
                  <Button
                    onClick={close}
                    fullWidth
                    variant="contained"
                    color="inherit"
                    style={{ margin: '5px' }}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item md={6}>
                  <Button
                    onClick={() =>
                      !!values?.dsColuna &&
                      salvaColunaOpcaoPergunta(values) &&
                      close()
                    }
                    variant="contained"
                    fullWidth
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          fastEditComponent={({ linha, close, edit }) => (
            <Grid container spacing={2}>
              <Grid item md={12}>
                <TextFieldMt
                  InputLabelProps={{ shrink: true }}
                  name="dsColuna"
                  label="Nome da Coluna"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  value={linha[3]}
                  onChange={(e) => edit({ value: e.target.value, index: 3 })}
                  helperText={!linha?.[3] ? 'Campo Obrigatório!' : ''}
                  error={!linha?.[3]}
                />
              </Grid>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={close}
                    fullWidth
                    variant="contained"
                    color="inherit"
                    style={{ margin: '5px' }}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    onClick={() =>
                      !!linha?.[3] &&
                      editarColunaOpcaoPergunta(linha, close) &&
                      close()
                    }
                    variant="contained"
                    fullWidth
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Editar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        />
      </DialogContent>
    </Dialog>
  )
}

export default ModalOpcoes
